import useThemeColor from "../../../hooks/useThemeColor";
import CustomerSelectionModal, {
  getMarketingCustomerKey,
  marketingCustomerDisplayName,
  normalizeMarketingCustomer,
} from "./customerSelectionModal/customerSelectionModal";

const getInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
};

const CustomerSelector = ({
  selectedCustomers,
  setSelectedCustomers,
  showModal,
  setShowModal,
  marketingGroupId = 0,
  onModalSubmit,
}) => {
  const themeColor = useThemeColor();
  const safeSelected = Array.isArray(selectedCustomers) ? selectedCustomers : [];

  const handleModalSubmit = (selected) => {
    setSelectedCustomers(selected);
    setShowModal(false);
    if (typeof onModalSubmit === "function") onModalSubmit(selected);
  };

  const removeCustomer = (customerKey) => {
    setSelectedCustomers((prev) =>
      (Array.isArray(prev) ? prev : []).filter(
        (c) => getMarketingCustomerKey(c) !== customerKey
      )
    );
  };

  return (
    <>
      {safeSelected.length > 0 ? (
        <>
          <div className="mkg-customers__toolbar">
            <div className="mkg-customers__count">
              <strong>{safeSelected.length}</strong> customer
              {safeSelected.length === 1 ? "" : "s"} selected
            </div>
            <button
              type="button"
              className="mkg-customers__btn"
              style={{ background: themeColor }}
              onClick={() => setShowModal(true)}
            >
              <i className="fa-solid fa-plus" />
              Add more
            </button>
          </div>

          <div className="mkg-customers__grid">
            {safeSelected.map((customer) => {
              const customerKey = getMarketingCustomerKey(customer);
              const normalized = normalizeMarketingCustomer(customer);
              const name = marketingCustomerDisplayName(normalized);
              const subtitle = [normalized.cust_Email, normalized.cust_Mobile]
                .filter(Boolean)
                .join(" · ");

              return (
                <div key={customerKey} className="mkg-customers__chip">
                  <div className="mkg-customers__chip-main">
                    <div
                      className="mkg-customers__avatar"
                      style={{
                        background: `${themeColor}22`,
                        color: themeColor,
                      }}
                    >
                      {getInitials(name)}
                    </div>
                    <div>
                      <p className="mkg-customers__name">{name}</p>
                      {subtitle && (
                        <div className="mkg-customers__meta">{subtitle}</div>
                      )}
                    </div>
                  </div>
                  <button
                    type="button"
                    className="mkg-customers__remove"
                    onClick={() => removeCustomer(customerKey)}
                    aria-label={`Remove ${name}`}
                    title="Remove"
                  >
                    <i className="fa fa-times" />
                  </button>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className="mkg-customers__empty">
          <div className="mkg-customers__empty-icon">
            <i className="fa fa-users" />
          </div>
          <p className="mkg-customers__empty-title">No customers selected</p>
          <p className="mkg-customers__empty-text">
            Add customers to this marketing group so campaigns can target the right audience.
          </p>
          <button
            type="button"
            className="mkg-customers__btn"
            style={{ background: themeColor }}
            onClick={() => setShowModal(true)}
          >
            <i className="fa-solid fa-plus" />
            Select customers
          </button>
        </div>
      )}

      <CustomerSelectionModal
        showModal={showModal}
        setShowModal={setShowModal}
        selectedCustomers={safeSelected}
        setSelectedCustomers={setSelectedCustomers}
        marketingGroupId={marketingGroupId}
        onSubmit={handleModalSubmit}
      />
    </>
  );
};

export default CustomerSelector;
